<div class="layout-topbar justify-content-between">
    <a class="layout-topbar-logo" routerLink="">
        <img
            src="assets/layout/images/logo.png"
            alt="logo"
            style="width: 50px; height: 50px"
        />
        <!-- <span>CAR BOOKING</span> -->
    </a>

    <!-- <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button> -->

    <p-tabMenu [model]="items"></p-tabMenu>

    <button
        #topbarmenubutton
        class="p-link layout-topbar-menu-button layout-topbar-button"
        (click)="layoutService.showProfileSidebar()"
    >
        <i class="pi pi-ellipsis-v"></i>
    </button>
    <!-- <p>{{ this.profile?.full_name }}</p> -->
    <div
        #topbarmenu
        class="layout-topbar-menu"
        [ngClass]="{
            'layout-topbar-menu-mobile-active':
                layoutService.state.profileSidebarVisible,
        }"
    >
        <app-notification></app-notification>
        <button
            class="p-link layout-topbar-button"
            (click)="userMenu.toggle($event)"
        >
            <i class="pi pi-user"></i>
            <span>Tài khoản</span>
        </button>
    </div>
</div>

<p-tieredMenu #userMenu [model]="userMenuItems" [popup]="true"></p-tieredMenu>
